import { MessagingContact } from 'messages/types'
import useFetchPersonSuggestions from 'civic-champs-shared/api/hooks/useFetchPersonSuggestions'
import { useCallback, useRef } from 'react'

export const useGetAllSearchableContacts = (): (() => Promise<MessagingContact[]>) => {
  const [fetch] = useFetchPersonSuggestions()
  const contacts = useRef<Promise<MessagingContact[]> | null>(null)

  return useCallback(() => {
    if (!contacts.current) {
      contacts.current = fetch()
        .then(({ suggestions }) =>
          suggestions.map(({ id, givenName, familyName, contact }) => ({
            id,
            firstName: givenName,
            lastName: familyName,
            ...(contact ? (contact.includes('@') ? { email: contact } : { phoneNumber: contact }) : {}),
          })),
        )
        .catch(error => {
          contacts.current = null
          throw error
        })
    }

    return contacts.current
  }, [fetch])
}
